const slideButtons = '[{"id":"1","label":"Conhe\\u00e7a a Cone","link":"\\/posts\\/a-cone","style":"","created":"2020-11-24 20:06:48","modified":"2020-11-28 01:38:32","slide_id":"1","slide_title":"Cone "}]';

export default JSON.parse(slideButtons);
